import * as Yup from "yup";

export const dataModel = {
  email: "",
  active: "",
  name: "",
  viveroUuid: "",
};

export const validationDataModel = Yup.object().shape({
  email: Yup.string().optional("forms.validations.required"),
  active: Yup.string().optional(""),
  name: Yup.string().optional(""),
  viveroUuid: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
